import { combineReducers } from 'redux';
import robot from './robot';
import intention from './intention';
import flow from './robot_flows';
import resources from './feature_resources';
import substance from './substance';
import user from './user';
import modalVersionModule from './modalVersionModule';
import intentionTags from './intentionTags';

export const rootReducer = combineReducers({
  robot,
  intention,
  flow,
  resources,
  substance,
  user,
  modalVersionModule,
  intentionTags
});
